import { mainSiteUrl } from '@/data/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20minimalist%20fashion%20flatlay%20with%20neatly%20arranged%20sneakers%20hoodies%20t-shirts%20and%20accessories%20on%20cream%20textured%20background%2C%20natural%20daylight%20from%20left%20side%2C%20editorial%20product%20photography%20style%2C%20warm%20neutral%20tones%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20organic%20composition%2C%20elegant%20minimal%20lifestyle%20shoot%2C%20Scandinavian%20design%20influence%2C%20high%20end%20catalog%20look&width=1800&height=900&seq=yoybuy-hero-bg-01&orientation=landscape"
          alt="Yoybuy Spreadsheet fashion products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-sm text-background-50 font-medium">2026 · Россия</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          Yoybuy Spreadsheet — Лучшие таблицы товаров Taobao, Weidian и 1688
        </h1>

        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          Используйте лучшие Yoybuy Spreadsheet для быстрого поиска товаров, безопасной доставки и выгодных покупок из Китая.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 text-base font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line mr-2"></i>
            Yoybuy Sheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 text-base font-semibold rounded-full border-2 border-background-50 text-background-50 hover:bg-background-50 hover:text-foreground-900 transition-all cursor-pointer"
          >
            <i className="ri-shopping-cart-line mr-2"></i>
            Купить сейчас
          </a>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">500+</div>
            <div className="text-xs md:text-sm text-background-50/70">Spreadsheet</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">10K+</div>
            <div className="text-xs md:text-sm text-background-50/70">Товаров</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">14</div>
            <div className="text-xs md:text-sm text-background-50/70">Категорий</div>
          </div>
        </div>

        <div className="mt-10">
          <a
            href="#categories"
            className="inline-flex items-center gap-2 text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
          >
            <span className="text-sm">Смотреть категории</span>
            <i className="ri-arrow-down-line animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
}